export class Profession {
    id: string
    companyName: string
    position: string
    startDate: any
    endDate: any
    isContinue: boolean
}